// Footer.tsx

import React from "react";
import { useTranslation } from "react-i18next";
import { MapPin } from "lucide-react";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
      <footer className="bg-white px-4 sm:px-6 lg:px-20 py-4 sm:py-5">
        <div className="flex justify-center text-center">
          <p className="text-[11px] sm:text-[13px] font-bold text-slate-400 uppercase tracking-[0.15em] sm:tracking-[0.2em]">
            {t("footer.copy")}
          </p>
        </div>
      </footer>
  );
};

export default Footer;